var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 99,
    width: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59.758 79.192h-6.654v-56.722h53.621v42.814h-6.654v-36.16h-40.313v50.067z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.635 89.02v-72.213l36.595-8.443v5.799h6.654v-14.163l-49.903 11.518v77.501h-9.981v9.981h119.77v-9.98z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m43.25 24.144h-16.635v6.654h16.635zm0 13.307h-16.635v6.654h16.635z",
    fill: "#5ec3b1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m43.25 37.451h-16.635v6.654h16.635zm0 13.308h-16.635v6.654h16.635v-6.653zm0 13.308h-16.635v6.654h16.635z",
    fill: "#5ec3b1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m93.155 37.451h-26.616v6.654h26.616zm0 12.975h-26.616v7.32h26.616zm0 13.308h-26.616v7.32h26.616z",
    fill: "#d62293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.d8ad0dac1daf4c18a9e81dee8745b637.svg";
export { ForwardRef as ReactComponent };